/**
 * Study Groups Service — API для управления учебными группами
 */

/**
 * Получить список групп организации
 */
export async function getStudyGroups(organizationId, { page = 1, pageSize = 25, search = null, isActive = null } = {}) {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('page_size', pageSize);
  if (search) params.append('search', search);
  if (isActive !== null) params.append('is_active', isActive);

  const response = await fetch(`/api/organizations/${organizationId}/study-groups?${params}`, {
    credentials: 'include',
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Не удалось загрузить группы');
  }
  return response.json();
}

/**
 * Получить группу по ID
 */
export async function getStudyGroup(organizationId, groupId) {
  const response = await fetch(`/api/organizations/${organizationId}/study-groups/${groupId}`, {
    credentials: 'include',
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Не удалось загрузить группу');
  }
  return response.json();
}

/**
 * Создать группу
 */
export async function createStudyGroup(organizationId, data) {
  const response = await fetch(`/api/organizations/${organizationId}/study-groups`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Не удалось создать группу');
  }
  return response.json();
}

/**
 * Обновить группу
 */
export async function updateStudyGroup(organizationId, groupId, data) {
  const response = await fetch(`/api/organizations/${organizationId}/study-groups/${groupId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Не удалось обновить группу');
  }
  return response.json();
}

/**
 * Удалить группу
 */
export async function deleteStudyGroup(organizationId, groupId) {
  const response = await fetch(`/api/organizations/${organizationId}/study-groups/${groupId}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Не удалось удалить группу');
  }
}

/**
 * Поставить/снять группу на паузу
 */
export async function togglePauseStudyGroup(organizationId, groupId) {
  const response = await fetch(`/api/organizations/${organizationId}/study-groups/${groupId}/pause`, {
    method: 'POST',
    credentials: 'include',
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Не удалось изменить статус группы');
  }
  return response.json();
}

/**
 * Записать ученика в группу
 */
export async function enrollStudent(organizationId, groupId, studentId) {
  const response = await fetch(`/api/organizations/${organizationId}/study-groups/${groupId}/students`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ student_id: studentId }),
  });
  if (!response.ok) {
    const error = await response.json();
    // Для конфликтов расписания вернём полный объект ошибки
    if (response.status === 409 && error.detail?.conflicts) {
      const err = new Error(error.detail.message || 'Конфликт расписания');
      err.conflicts = error.detail.conflicts;
      throw err;
    }
    throw new Error(error.detail || 'Не удалось записать ученика');
  }
  return response.json();
}

/**
 * Убрать ученика из группы
 */
export async function removeStudent(organizationId, groupId, studentId) {
  const response = await fetch(`/api/organizations/${organizationId}/study-groups/${groupId}/students/${studentId}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Не удалось убрать ученика');
  }
}
